module.exports = __webpack_public_path__ + "static/media/gc-plaka-bad.0ed459e2.png";